import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { CopyLinkButton } from './components/CopyLinkButton';
import { EditURLButton } from './components/EditURLButton';
import { useShareUrl } from './hooks/useShareUrl';

export const ShareUrl: React.FC = () => {
	const { data, actions } = useShareUrl();
	const { translate } = useI18n();

	return (
		<div data-testid="share-url" className="rounded-small bg-background-overlay flex flex-col gap-2 p-2">
			<div className="rounded-small bg-background-base px-4 py-2">
				<Text className="text-size-body-xs">
					<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.copy_link.unique_link_label" />
				</Text>
				<div className="flex flex-row items-center justify-between">
					<Text
						aria-label={translate('corgi.petition.starter_dashboard.grow_petition.copy_link.short_url_aria_label')}
						data-testid="copylink-input"
						className="text-size-body-small-bold max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap"
					>
						{data.shareUrl}
					</Text>
					{data.canEditUrl && <EditURLButton data-qa="edit-url-button" onEditUrl={actions.onEditUrl} />}
				</div>
			</div>
			<div>
				<CopyLinkButton shareUrl={data.shareUrl} />
			</div>
		</div>
	);
};
